import axios from 'axios'
import store from '@/store'
import { Toast } from 'vant'

const service = axios.create({
  baseURL: 'http://wk-api.kingdraw.com/api/',
  // baseURL: 'http://localhost:5000/api/',
  timeout: 60000
})

// request interceptor
service.interceptors.request.use(
  config => {
    // 取出基础设备信息
    const device = store.getters.header.device
    // 检查设备信息
    if (device) {
      // 循环赋值，将基础设备信息写到header中
      for (const key in device) {
        const value = device[key]
        config.headers[key] = value
      }
    }
    config.headers['h5-proj'] = 'application'
    config.headers['token'] = store.getters.token

    // 判断当前设备信息不包含平台类型，主动添加
    if (!config.headers.hasOwnProperty('platform')) {
      config.headers['platform'] = '5'
    }
    // 判断当前设备信息不包含平台类型，主动添加
    if (!config.headers.hasOwnProperty('platformType')) {
      config.headers['platformType'] = '0'
    }

    console.log('============================================')
    console.log('request => ' + config.baseURL + config.url)
    console.log('headers ->', config.headers)
    if (config.data instanceof FormData) {
      const keys = config.data.keys()
      console.log('FormData:')
      for (;;) {
        const item = keys.next()
        if (item.done) {
          break
        } else {
          console.log('->', item.value, '=', config.data.get(item.value))
        }
      }
    } else {
      console.log('data ->', config.data)
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    console.log('response => ', response.data)
    console.log('============================================')

    const res = response.data
    if (res.code !== 200) {
      Toast.error(res.message)
      if (res.code === 401) {
        // 退出登录的时候，也清空token数据
        store.dispatch('user/updateToken', '')
        // noticeAppLogout()
      }
    }
    return response.data
  },
  error => {
    Toast.error('网络错误,请检查连接')
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js